import IslandProgressionResponse from '@/store/models/contents/island_progression_response';
import ThematicResponse from '@/store/models/contents/thematic_response';
import ThematicsByLevelResponse from '@/store/models/contents/thematic_by_level_response';
import TeachbotGroupsResponse from '@/store/models/contents/teachbot_groups_response';
import GrammarGroupsResponse from '@/store/models/contents/grammar_groups_response';
import ExpressionResponse from '@/store/models/contents/expression_response';
import ExpressionsResponse from '@/store/models/contents/expressions_response';
import ExpressionsResponseAll from '@/store/models/contents/expressions_all_response';
import ExpressionTagsResponse from '@/store/models/contents/expression_tags_response';
import LessonResponse from '@/store/models/contents/lesson_response';
import EvaluateResponse from '@/store/models/contents/evaluate_response';
import LessonInfoResponse from '@/store/models/contents/lesson_info_response';
import Lessons from '@/store/models/contents/lessons';
import CatalogResponse from '@/store/models/contents/catalog_response';
import WeeklyEnglishLessonsResponse from '@/store/models/contents/weekly_english_lessons_response';
import axios from 'axios';
import { fromLongToShort } from '@/components/shared/languageCodes';
import store from '@/store';

import {
  fetchData,
  googleTranslate,
  witAi,
  apiURL,
  textToSpeech,
} from './api_helper';

const crypto = require('crypto');

const fetchIslandProgression = level =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${level}/contents/islands/progression`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const progression = new IslandProgressionResponse();
        progression.map(result.response);
        resolve(progression);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchThematics = (level, thematic) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${level}/contents/thematics/${thematic}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const thematicResponse = new ThematicResponse();
        thematicResponse.map(result.response);
        resolve(thematicResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchThematicsByLevel = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${data.level}/contents/thematics/level/${data.thematic}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const thematicsByLevelResponse = new ThematicsByLevelResponse();
        thematicsByLevelResponse.map(result.response);
        resolve(thematicsByLevelResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchLesson = (level, lesson) =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}${level}/contents/lesson/${lesson}`;
    const user = store.state.users.loggedInUserProfile.user;
    const xKey = window.getParameterByName('x-key');
    if (xKey) {
      endpointURL = `${endpointURL}?key=${xKey}`;
    }
    const requestBody = {
      device_language:
        fromLongToShort[store.getters['settings/userSelectedLanguage']],
    };
    fetchData(endpointURL, 'get', requestBody)
      .then((result) => {
        const lessonResponse = new LessonResponse();
        if (user && user.isDktMember && !xKey) {
          decryptMessage(result.response).then((decryptedData) => {
            const parsedData = JSON.parse(decryptedData);
            const dataForMap = parsedData.chatbot_lesson
              ? parsedData.chatbot_lesson
              : parsedData.lesson;
            lessonResponse.map(dataForMap);
            resolve(lessonResponse);
          });
        } else {
          lessonResponse.map(result.response);
          resolve(lessonResponse);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchExpressionLesson = (level, params) =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}${level}/contents/expression_test/${params.expressionType}/${params.expressionStatus}`;
    const user = store.state.users.loggedInUserProfile.user;
    if (params.expressionTagId !== undefined) {
      endpointURL = `${endpointURL}/${params.expressionTagId}`;
    }
    fetchData(endpointURL, 'get')
      .then((result) => {
        const lessonResponse = new LessonResponse();
        if (user && user.isDktMember) {
          decryptMessage(result.response).then((decryptedData) => {
            const parsedData = JSON.parse(decryptedData);
            const dataForMap = parsedData.expression_test;
            lessonResponse.map(dataForMap);
          });
        } else {
          lessonResponse.map(result.response);
        }
        lessonResponse.map(result.response);
        resolve(lessonResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchLevelUpLesson = (apiLevel, level) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/contents/monster/${level}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const lessonResponse = new LessonResponse();
        lessonResponse.map(result.response);
        resolve(lessonResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchPlacementLesson = level =>
  new Promise((resolve, reject) => {
    const user = store.state.users.loggedInUserProfile.user;
    const learnedLanguageCode =
      store.getters['settings/getSelectedLearnedLanguage'];
    const endpointURL = `${apiURL}${level}/contents/placement_test?learned_language_short_code=${learnedLanguageCode}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const lessonResponse = new LessonResponse();
        if (user && user.isDktMember) {
          decryptMessage(result.response).then((decryptedData) => {
            const parsedData = JSON.parse(decryptedData);
            const dataForMap = parsedData.placement_test;
            lessonResponse.map(dataForMap);
            resolve(lessonResponse);
          });
        } else {
          lessonResponse.map(result.response);
          resolve(lessonResponse);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

// const fetchPlacementLesson = async (level) => {
//   const endpointURL = `${apiURL}${level}/contents/placement_test`;
//   const token = store.getters.getAuthToken;
//   const shortLanguageCode = store.state.settings.userSelectedLanguage;
//   const config = {
//     headers: {
//       'Content-Type': 'application/json',
//       'Cache-Control': 'no-cache',
//       'Auth-Token': token,
//       'Accept-Languages': shortLanguageCode,
//     },
//   };
//   const result = await axios.get(endpointURL, config);
//   const lessonResponse = new LessonResponse();
//   lessonResponse.map(result.data.response);
//   if (lessonResponse.hasError()) {
//     throw new Error(lessonResponse.errorMessage());
//   }
//   return lessonResponse;
// };

const fetchCatalog = (level, payload) =>
  new Promise((resolve, reject) => {
    let endpointURL = '';
    if (payload.key) {
      endpointURL = `${apiURL}${level}/contents/catalog?category_limit=${payload.limit}&key=${payload.key}&page=0&page_number=0&group_number=0&tag_id=0`;
    } else {
      endpointURL = `${apiURL}${level}/contents/catalog?category_limit=${payload.limit}&page=${payload.page}&page_number=0&group_number=0&tag_id=0`;
    }
    fetchData(endpointURL, 'get')
      .then((result) => {
        const catalogResponse = new CatalogResponse();
        catalogResponse.map(result.response);
        if (payload.key) {
          const finalResult = {
            ...catalogResponse,
            mode: 'search',
          };
          resolve(finalResult);
        } else {
          const finalResult = {
            ...catalogResponse,
            mode: 'all',
            page: payload.page,
          };
          resolve(finalResult);
        }
        // resolve(catalogResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchLessonInfo = (level, data) =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}${level}/contents/lesson/${data.lesson}/info`;
    if (data.league_code) {
      endpointURL += `?league_code=${data.league_code}`;
    }
    fetchData(endpointURL, 'get')
      .then((result) => {
        const lessonInfoResponse = new LessonInfoResponse();
        lessonInfoResponse.map(result.response);
        resolve(lessonInfoResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchExpression = (level, expression) =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}${level}/contents/expression/${expression}`;
    const xKey = window.getParameterByName('x-key');
    if (xKey) {
      endpointURL = `${endpointURL}?key=${xKey}`;
    }
    fetchData(endpointURL, 'get')
      .then((result) => {
        const expressionResponse = new ExpressionResponse();
        expressionResponse.map(result.response);
        resolve(expressionResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchExpressions = (level, expression) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${level}/contents/expressions/${expression}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const expressionsResponse = new ExpressionsResponse();
        expressionsResponse.map(result.response);
        resolve(expressionsResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchExpressionsAll = (level, expression) =>
  new Promise((resolve, reject) => {
    let endpointURL = '';
    if (expression.id) {
      endpointURL = `${apiURL}${level}/contents/expressions/${expression.type}/${expression.category}/?tag_id=${expression.id}&page=${expression.page}`;
    } else {
      endpointURL = `${apiURL}${level}/contents/expressions/${expression.type}/${expression.category}/?page=${expression.page}`;
    }
    fetchData(endpointURL, 'get')
      .then((result) => {
        const expressionsResponseAll = new ExpressionsResponseAll();
        expressionsResponseAll.map(result.response);
        resolve(expressionsResponseAll);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchExpressionTags = level =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${level}/contents/expression_tags`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const expressionTagsResponse = new ExpressionTagsResponse();
        expressionTagsResponse.map(result.response);
        resolve(expressionTagsResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchTeachbotSkeleton = level =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${level}/contents/chatbots_skeleton`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const res = result.response;
        const groups = [];
        res.forEach((item) => {
          const teachbotGroupsResponse = new TeachbotGroupsResponse();
          teachbotGroupsResponse.map(item);
          groups.push(teachbotGroupsResponse);
        });
        resolve(groups);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchTeachbot = (apiLevel, level) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/contents/chatbots/${level}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const teachbotGroupsResponse = new TeachbotGroupsResponse();
        teachbotGroupsResponse.map(result.response);
        resolve(teachbotGroupsResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchGrammarSkeleton = level =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${level}/contents/grammars_skeleton`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const res = result.response;
        const groups = [];
        res.forEach((item) => {
          const grammarGroupsResponse = new GrammarGroupsResponse();
          grammarGroupsResponse.map(item);
          groups.push(grammarGroupsResponse);
        });
        resolve(groups);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchGrammar = (apiLevel, level) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/contents/grammars/${level}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const grammarGroupsResponse = new GrammarGroupsResponse();
        grammarGroupsResponse.map(result.response);
        resolve(grammarGroupsResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const favouriteExpression = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/contents/favourite_expression/${payload.id}`;
    fetchData(endpointURL, 'post', payload.id)
      .then((result) => {
        const expressionResponse = new ExpressionResponse();
        expressionResponse.map(result.response);
        resolve(expressionResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const translateText = text =>
  new Promise((resolve, reject) => {
    googleTranslate(
      `https://translation.googleapis.com/language/translate/v2?q=${text.query}&key=AIzaSyAvAmtWhhd592xqsr4TgbtGh9ZSuOrD-Yc&source=${text.source == 'enpam' ? 'en' : text.source}&target=${text.target}`,
    )
      .then((result) => {
        if (text.source === 'en' && text.target === 'en') {
          resolve({
            data: {
              translations: [
                {
                  translatedText: text.query,
                },
              ],
            },
          });
        } else {
          resolve(result);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

const sendMessageToBot = msg =>
  new Promise((resolve, reject) => {
    fetchData(`${msg.url}/WEBINTERFACE/SPEECH/api.php`, 'post', msg)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const transcribe = data =>
  new Promise((resolve, reject) => {
    witAi('https://api.wit.ai/speech', data)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const evaulateLesson = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}${apiLevel}/evaluate/`;
    if (data.lessonType === 'placement_test') {
      // Placement test
      endpointURL = `${endpointURL}placement_test`;
    } else if (data.lessonType === 'expression_exercise') {
      // Expression exercise
      endpointURL = `${endpointURL}expression_test`;
    } else {
      endpointURL = `${endpointURL}lesson/${data.lessonId}`;
    }
    const xKey = window.getParameterByName('x-key');
    if (xKey) {
      endpointURL = `${endpointURL}?key=${xKey}`;
    }

    const dataToPost = data.results !== undefined ? data.results : data.goals;
    const user = store.state.users.loggedInUserProfile.user;

    if (Object.keys(user).length !== 0) {
      dataToPost.lesson_id = data.lessonId;
    }
    dataToPost.solution_time = Math.floor(data.solution_time);

    if (data.assignment_id) {
      dataToPost.assignment_id = data.assignment_id;
      dataToPost.test_type_statistics = data.test_type_statistics;
      if (data.league_code) {
        dataToPost.league_code = data.league_code;
      }
    }

    if (data.repeated_tests) {
      dataToPost.repeated_tests = data.repeated_tests;
    }

    if (data.advanced_test_results) {
      dataToPost.advanced_test_results = data.advanced_test_results;
    }

    if (user && user.isDktMember && !xKey) {
      encryptMessage(JSON.stringify(dataToPost)).then((encryptedData) => {
        fetchData(endpointURL, 'post', { data: encryptedData })
          .then((result) => {
            const evaluateResponse = new EvaluateResponse();
            evaluateResponse.map(result.response);
            resolve(evaluateResponse);
          })
          .catch((error) => {
            reject(error);
          });
      });
    } else {
      fetchData(endpointURL, 'post', dataToPost)
        .then((result) => {
          const evaluateResponse = new EvaluateResponse();
          evaluateResponse.map(result.response);
          resolve(evaluateResponse);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });

const fetchWeeklyEnglishLessons = (level, pageSize) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${level}/contents/lesson/weekly_lessons${
      pageSize != null ? `?page_size=${pageSize}` : ''
    }`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const lessonsResponse = new WeeklyEnglishLessonsResponse();
        lessonsResponse.map(result.response);
        resolve(lessonsResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const openIsland = (apiLevel, islandLevel) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/contents/open_island`;
    fetchData(endpointURL, 'post', { level: islandLevel })
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const loadGrammarsByIds = (level, ids) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${level}/contents/grammars_by_lesson_ids`;
    fetchData(endpointURL, 'post', { lesson_ids: ids })
      .then((result) => {
        const grammarLessons = result.response.map((x) => {
          const lessonResponse = new LessonResponse();
          lessonResponse.map(x);
          return lessonResponse;
        });
        resolve(grammarLessons);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchTextToSpeech = data =>
  new Promise((resolve, reject) => {
    textToSpeech(data)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchAllExpressions = (level, learnedLanguage) =>
  new Promise((resolve, reject) => {
    const classroomSyncKey =
      'A97suUmYaGbW2H7QTvGXWL6H4J8sCKlCrhVUJT3bqALPW2aVUmLLkskbPkNT8nw4u2hNmSw3KnBdR7btazHEvFjJRtLMURS4bHZ7TZ6mn5Hf2CjeSRBTxSkzzSTtKj2c';
    const endpointURL = `${apiURL}${level}/contents/all_expression_tags?key=${classroomSyncKey}&learned_language_short_code=${learnedLanguage}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchAllLessonsByLessonIds = (level, lessonData) =>
  new Promise((resolve, reject) => {
    const learnedLanguageCode =
      store.getters['settings/getSelectedLearnedLanguage'];
    const classroomSyncKey =
      'A97suUmYaGbW2H7QTvGXWL6H4J8sCKlCrhVUJT3bqALPW2aVUmLLkskbPkNT8nw4u2hNmSw3KnBdR7btazHEvFjJRtLMURS4bHZ7TZ6mn5Hf2CjeSRBTxSkzzSTtKj2c';
    const endpointURL = `${apiURL}${level}/contents/lessons_by_lesson_ids?key=${classroomSyncKey}`;
    const requestData = {
      ...lessonData,
    };
    if (!lessonData.learned_language_short_code) {
      requestData.learned_language_short_code = learnedLanguageCode;
    }
    fetchData(endpointURL, 'post', requestData)
      .then((result) => {
        const data = [];
        result.response.map((item) => {
          const res = new Lessons();
          res.map(item);
          data.push(res);
        });
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getClasroomLeaderboardByClassCode = (apiLevel, body) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/leagues/${body.classCode}?league_user_limit=${body.leagueUserLimit}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

function decryptMessage(message) {
  return new Promise((resolve, rej) => {
    const decipher = crypto.createDecipheriv(
      'aes-256-cbc',
      'cRfU%Xn_r5u8x0A-DqG6KbPe=gVkYp3s',
      'G-Ka_dS=VkYp%s6v',
    );

    let decryptedData = decipher.update(message, 'Base64', 'UTF-8');

    decryptedData += decipher.final('UTF-8');

    resolve(decryptedData);
  });
}

function encryptMessage(message) {
  return new Promise((resolve, rej) => {
    const cipher = crypto.createCipheriv(
      'aes-256-cbc',
      'dSgV=Xp2s5v8y-BjE4_5M%QeThWmZq3t',
      'Ja%cRfUjXn2r=u8x',
    );

    let encryptedData = cipher.update(message, 'UTF-8', 'Base64');

    encryptedData += cipher.final('Base64');

    resolve(encryptedData);
  });
}
export default {
  fetchIslandProgression,
  fetchThematics,
  fetchCatalog,
  fetchThematicsByLevel,
  fetchLesson,
  fetchLessonInfo,
  fetchExpression,
  fetchExpressions,
  fetchExpressionsAll,
  fetchExpressionTags,
  fetchTeachbotSkeleton,
  fetchTeachbot,
  fetchGrammarSkeleton,
  fetchGrammar,
  favouriteExpression,
  evaulateLesson,
  translateText,
  sendMessageToBot,
  transcribe,
  fetchWeeklyEnglishLessons,
  fetchExpressionLesson,
  fetchPlacementLesson,
  fetchLevelUpLesson,
  openIsland,
  loadGrammarsByIds,
  fetchTextToSpeech,
  fetchAllExpressions,
  fetchAllLessonsByLessonIds,
  getClasroomLeaderboardByClassCode,
};
